import { TILE_WIDTH, TILE_HEIGHT } from '@/shared/constants';

export interface ScreenPoint {
  x: number;
  y: number;
}

export interface WorldPoint {
  x: number;
  y: number;
}

/** Screen-space drag handle for town-editor props and NPCs (ground anchor). */
export const EDITOR_OBJECT_ANCHOR_PX = 40;

/** Admin town-editor overlay markers (click targets + selection highlight). */
export type EditorOverlayItem = {
  kind: 'object' | 'building' | 'npc' | 'center';
  id: number;
  worldX: number;
  worldY: number;
  selected: boolean;
  footprintW?: number;
  footprintH?: number;
  footprint?: { minX: number; minY: number; maxX: number; maxY: number };
  radius?: number;
};

export function worldToScreen(wx: number, wy: number): ScreenPoint {
  return {
    x: (wx - wy) * (TILE_WIDTH / 2),
    y: (wx + wy) * (TILE_HEIGHT / 2),
  };
}

export function screenToWorld(sx: number, sy: number): WorldPoint {
  return {
    x: (sx / (TILE_WIDTH / 2) + sy / (TILE_HEIGHT / 2)) / 2,
    y: (sy / (TILE_HEIGHT / 2) - sx / (TILE_WIDTH / 2)) / 2,
  };
}
